import React from 'react';
import * as PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import PlantManagementUtility from "../../components/plantManagement/PlantManagementUtility";

const TEXT_FONT_SIZE_DEFAULT = 14;
const TEXT_FONT_SIZE_MEDIUM = 12;
const BASE_WIDTH = 168 * 0.7;
const BIG_WIDTH = BASE_WIDTH + BASE_WIDTH / 3;

class HeatExchangerInAddMenu extends React.Component {

    // 熱交名が枠を超えているか確認
    isTextWidthOverflowNode() {
        let text = this.props.heatExchanger.instrumentApparatus + this.props.heatExchanger.instrumentMachineNumber;
        let textWidth = text.length * TEXT_FONT_SIZE_DEFAULT;
        const rectWidth = PlantManagementUtility.getHeatExchangerRectWidth(this.props.heatExchanger.instrumentLength);
        if (rectWidth === BASE_WIDTH) {
            return textWidth - 27 > rectWidth;
        } else if (rectWidth === BIG_WIDTH) {
            return textWidth - 52 > rectWidth;
        }
        return textWidth - 20 > rectWidth;
    }

    render() {
        let text = this.props.heatExchanger.instrumentApparatus + this.props.heatExchanger.instrumentMachineNumber;
        let fontSize = TEXT_FONT_SIZE_DEFAULT
        if(this.isTextWidthOverflowNode()) {
            fontSize = TEXT_FONT_SIZE_MEDIUM  
        }

        return (
            <div
                hidden={this.props.hidden}
                className={this.props.className}
                style={{
                    width: PlantManagementUtility.getHeatExchangerRectWidth(this.props.heatExchanger.instrumentLength),
                    height: PlantManagementUtility.getHeatExchangerRectHeight(this.props.heatExchanger.instrumentNumberOfLines)
                }}
            >
                <Button
                    fullWidth
                    variant={"contained"}
                    color={"inherit"}
                    onClick={() => {
                        this.props.onClick(this.props.heatExchanger);
                    }}
                    style={{
                        backgroundColor: PlantManagementUtility.getBackgroundColorByHeatExchanger(this.props.heatExchanger),
                        color: PlantManagementUtility.getTextColorByHeatExchanger(this.props.heatExchanger),
                        height: '100%',
                        padding: 0,
                        fontSize: fontSize
                    }}
                >
                    <div style={{width: '100%', overflow: 'hidden'}}>
                        {text}
                    </div>
                </Button>
            </div>
        );
    }
}

HeatExchangerInAddMenu.propTypes = {
    className: PropTypes.string,
    heatExchanger: PropTypes.object.isRequired,
    hidden: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

export default HeatExchangerInAddMenu;
